import { PaymentMethod } from '@frontend/api-payment-plans';
import { useValidateACHTransactionBalance } from '@frontend/api-weave-pay';
import { PaymentsFeatureFlags } from '@frontend/payments-hooks';
import { useAppFlagStore } from '@frontend/shared';

export interface UseValidateACHBalanceOptions {
  amount: number;
  locationId: string | undefined;
  paymentMethod?: PaymentMethod;
}

export const useValidateACHBalance = ({ amount, locationId, paymentMethod }: UseValidateACHBalanceOptions) => {
  const { mutateAsync } = useValidateACHTransactionBalance();
  const { getFeatureFlagValue } = useAppFlagStore();
  const enabledACHBalanceCheck = getFeatureFlagValue({
    flagName: PaymentsFeatureFlags.EnableACHBalanceCheck,
    locationIds: [locationId ?? ''],
  });
  const paymentMethodId = paymentMethod?.id || '';

  if (!enabledACHBalanceCheck || !paymentMethodId || paymentMethod?.type !== 'us_bank_account') {
    return { isACHBalanceValidated: (): boolean => true };
  }

  const isACHBalanceValidated = async (): Promise<boolean> => {
    const data = await mutateAsync({ locationId: locationId ?? '', amount, paymentMethodId });

    return !!data?.balanceAvailable;
  };

  return { isACHBalanceValidated };
};
